import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { RiCloudLine } from '@remixicon/react';
import {
  CopyableValue,
  ExternalLink,
  InfraField,
  InfraSection,
  InfraStack,
  Text,
} from '../ui/InfraPrimitives';

export const AzureInfrastructureInfoCard = () => {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations || {};
  const templateType = annotations['infrastructure.backstage.io/type'];
  const environmentName =
    annotations['infrastructure.backstage.io/environment-name'];

  const upn = annotations['azure.infrastructure/user-principal-name'];
  const displayName = annotations['azure.infrastructure/display-name'];
  const resourceGroup = annotations['azure.infrastructure/resource-group'];
  const location = annotations['azure.infrastructure/location'];
  const subscriptionId = annotations['azure.infrastructure/subscription-id'];
  const role = annotations['azure.infrastructure/role'];
  const consoleUrl = annotations['azure.infrastructure/console-url'];
  const temporaryPassword =
    annotations['azure.infrastructure/temporary-password'];

  const isAzure = Boolean(templateType?.startsWith('azure-'));
  const hasAzureInfo = Boolean(upn || resourceGroup);

  if (!isAzure || !hasAzureInfo) {
    return null;
  }

  return (
    <InfoCard
      title="Temporary Azure Login"
      subheader={`Environment: ${environmentName || 'N/A'}`}
      icon={<RiCloudLine size={20} />}
    >
      <InfraStack>
        <InfraSection title="Sign in">
          <Text variant="body-medium">
            Open the Azure portal with this Entra ID user. Change the password
            at first sign-in. Access is limited to the resource group below.
          </Text>
          {upn && <CopyableValue label="User principal name:" value={upn} />}
          {temporaryPassword && (
            <CopyableValue
              label="Temporary password:"
              value={temporaryPassword}
            />
          )}
          {displayName && (
            <InfraField label="Display name:" value={displayName} />
          )}
          {consoleUrl && (
            <InfraField
              label="Portal:"
              value={<ExternalLink href={consoleUrl}>Resource group</ExternalLink>}
              mono={false}
            />
          )}
        </InfraSection>
        <InfraSection title="Scope">
          {resourceGroup && (
            <CopyableValue label="Resource group:" value={resourceGroup} />
          )}
          {location && <InfraField label="Region:" value={location} />}
          {role && <InfraField label="Role:" value={role} />}
          {subscriptionId && (
            <CopyableValue label="Subscription:" value={subscriptionId} />
          )}
        </InfraSection>
      </InfraStack>
    </InfoCard>
  );
};
